import 'intersection-observer';
(function () {
    if ( typeof NodeList.prototype.forEach === "function" ) return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();
$(document).ready(function(){


    var booleanSliderActu = true;
    var booleanSliderNav= true;
    var booleanSliderActuVerif = true;


    $(".header-slider").slick({
        dots:true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('section.slider .controls .prev'),
        nextArrow: $('section.slider .controls .next')
    });



    $("main.home .prestations-slider").slick({
        prevArrow: $('main.home section.prestations .controls .prev'),
        nextArrow: $('main.home section.prestations .controls .next'),
        slidesToShow: 3,
        equalizeHeight:true,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    createSliderForMobile();

    $('#hamburger').on('click', function(e) {
        e.preventDefault();



        $(this).toggleClass('active');
        $(".hide-site").toggleClass('active');



        $('.menu-principal').toggleClass("active");

        // Calcule de la hauteur
        overflowPanel();
    });

    $(".hide-site").on('click', function(e) {
        e.preventDefault();
        $('#hamburger, .hide-site, .menu-principal').removeClass('active');
    });






    $('#click-search').on('click', function(e) {
        e.preventDefault();
        $('.search-field').focus();
        $(".search-form").toggleClass('active');

    })
    $('.close').on('click', function(e) {
        e.preventDefault();
        $(".search-form").toggleClass('active');
    })

    // // A voir si on garde selon Camille
    // if(document.querySelector('.scroll-to')) {
    //     $([document.documentElement, document.body]).animate({
    //         scrollTop: $(".scroll-to").offset().top
    //     }, 1000);
    // }


    window.addEventListener('resize',function(e) {
        overflowPanel();
        createSliderForMobile();
        ajustHeaderMobile();
    });



    $('.menu-item-has-children').on('click', function(e) {

        if($(window).width() < 700) {
            if($(this).hasClass("active")) {
                $(".menu-item-has-children").removeClass('active');
            } else {
                $(".menu-item-has-children").removeClass('active');
                $(this).toggleClass('active');
            }
        }

    });

    $('.list_category_mobile li').on('click', function(e) {

        if($(window).width() < 700) {

            if($(this).hasClass("active")) {
                $(".list_category_mobile li").removeClass('active');
            } else {
                $(this).toggleClass('active');
            }
        }

    });

    /* Accordion */
    $('.accordion .toggle_accordion').click(function(j) {
        var dropDown = $(this).closest('li').find('ul');

        $(this).closest('.accordion').find('ul').not(dropDown).slideUp();

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).closest('.accordion').find('.toggle_accordion.active').removeClass('active');
            $(this).addClass('active');
        }

        dropDown.stop(false, true).slideToggle();

        j.preventDefault();
    });
    /*$( "#primary-menu > li" ).each(function() {
     $(this).mouseenter(function() {
     $( "#primary-menu > li" ).find("active").removeClass('active')
     $(this).find('.sub-menu').addClass("active");
     });
     });*/
    function overflowPanel(){

        var windowHeight = $(window).outerHeight(true);
        if ($(window).width() < 1024) {
            var maxHeight = windowHeight - $(".alpes_header").outerHeight();
        }
        else {
            var maxHeight = windowHeight - $(".alpes_header").outerHeight();
        }

        $( "#primary-menu .sub-menu" ).each(function() {

            if ($(this).outerHeight(true) > maxHeight){

                if(window.innerWidth >= 700) {
                    $(this).css("height", maxHeight);
                } else {
                    $(this).css("height", "auto");
                }
            }
            else{

                if(window.innerWidth >= 700) {
                    $(this).css("height", maxHeight);
                    $(".menu-principal").css("height", maxHeight);
                } else {
                    $(".menu-principal").css("height", "auto");
                    $(this).css("height", "auto");
                }

                $(".menu-principal").css("top", $(".alpes_header").outerHeight());
                $(this).removeAttr("style");
            }
        });
    }


    if(document.querySelector('.slider-for')) {
        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: false,
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            initialSlide: 1,
            slidesToShow: 3,

            asNavFor: '.slider-for',
            // dots: true,
            centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });

    }

    // Préremplissage du champ offer_id
    var offerGetParameter = getUrlParameter("offre");
    var offerLinkedParameter = getUrlParameter("post");
    if(offerGetParameter != null && typeof(".wpforms-form") !== "undefined" && typeof(".wpcf7-form input.offer_id") !== "undefined"){
        $(".wpforms-form input.offer_id").val(offerGetParameter);
    }
    if(offerLinkedParameter != null && typeof(".wpforms-form") !== "undefined" && typeof(".wpcf7-form input.linked_post_id") !== "undefined"){
        $(".wpforms-form input.linked_post_id").val(offerLinkedParameter);
    }

    function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }


    function createSliderForMobile(){
        if($(window).width() <= 768 && booleanSliderActu) {

            $(".slider-actu").slick({
                prevArrow: $('.news .controls .prev'),
                nextArrow: $('.news .controls .next'),
                slidesToShow: 1,
                slidesToScroll: 1
            });
            $(".slider-jobs").slick({
                prevArrow: $('.jobs .controls .prev'),
                nextArrow: $('.jobs .controls .next'),
                slidesToShow: 1,
                slidesToScroll: 1
            });


            booleanSliderActu = false;
        }  else{

            if(!booleanSliderActu && window.innerWidth > 768) {
                $(".slider-actu .controls").hide();
                $(".slider-actu").slick('unslick');

                $(".slider-jobs .controls").hide();
                $(".slider-jobs").slick('unslick');
                booleanSliderActu = true;

            }
        }

        var $slider = $("#menu-nav-entreprise");

        if($(window).width() <= 640 && booleanSliderNav) {

            if(document.querySelector('.scroll-to') && $(window).width() <= 640 && document.referrer.indexOf(document.URL)) {

                $("#menu-nav-carrieres").on('init', function(){
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".news").offset().top
                    }, 1000);
                });



            }

            $("#menu-nav-carrieres").slick({
                slidesToShow: 1,
                slidesToScroll: 1
            });
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1
            });
            booleanSliderNav = false;



        } else if(booleanSliderNav === false && $(window).width() >= 641) {
                $("#menu-nav-carrieres").slick('unslick');
                $slider.slick('unslick');
                booleanSliderNav = true;

        }


    }
    var cibles = document.querySelectorAll('.js-observer');

    var options = {
        threshold: 0.2 /* 50% */
    };

    var isMobile = false;

    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
        $(".js-observer").removeClass("js-observer");
    }
    else{
        var observer = new IntersectionObserver(
            onIntersection,
            options
        );

        cibles.forEach(cible => {
            observer.observe(cible);
        });
    }



    function onIntersection(entries) {
        var target;
        entries.forEach((entry) => {
        if (entry.intersectionRatio > 0.2) {

            TweenMax.staggerFromTo(entry.target.querySelectorAll(".bloc-list"), 0.4, {
                autoAlpha:0,
                y: 60,
                ease: Quad.easeOut,
            }, {
                autoAlpha:1,
                y: 0,
                ease: Quad.easeOut,
            }, 0.1)
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        }
    })

    }


    /// PARTIE SELECT

    var inputs = document.querySelectorAll( '.label-input' );
    Array.prototype.forEach.call( inputs, function( input )
    {
        var label	 = input;
        var labelVal = label.querySelector('.label-custom');

        input.addEventListener( 'change', function( e )
        {
            var fileName = '';
            // console.log(fileName);
            if( this.files && this.files.length > 1 )
                fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
            else
                fileName = e.target.value.split( '\\' ).pop();
            if( fileName )
                label.querySelector( 'span' ).innerHTML = fileName;
        });

        // Firefox bug fix
        input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
        input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
    });


    /* Bandeau header mobile */
    ajustHeaderMobile();
    function ajustHeaderMobile(){
        if(typeof($("figure.hub-head") !== "undefined") && !$("figure.hub-head").hasClass("simple")) {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 640) {
                var height = $(".hub-head p span").outerHeight(true),
                    margin_span = 4;
                $(".hub-head").css({"margin-bottom": height+margin_span+"px", "overflow": "visible"});
                $(".hub-head > div").css("top", height-margin_span+"px");
            }
            else {
                $(".hub-head").css({"margin-bottom": "0px", "overflow": "hidden"});
                $(".hub-head > div").css("top", "0px");

            }
        }
    }

    /* Modal partage */
    if(typeof($(".a2a_button_email")) !== "undefined"){
        $(".a2a_button_email").hide();
        $('<a href="#modal_partage" class="show_modal_partage">&nbsp;</a>').insertAfter(".a2a_button_email");
        var post_id = parseInt($(".hidden.post_id").html());
        $('.partage_post_id input').val(post_id);

        $(".a2a_button_email, .show_modal_partage").on("click",function(e){
            e.preventDefault();
            $(".modal").addClass("in");
        });

        $(".bkg-modal, .modal .btn-close").on('click',function(){
            $(".modal").removeClass("in");
        });
    }
    // Préremplissage du champ message pour le partage
    if(typeof($(".modal")) !== "undefined" && $(".modal").length) {
        var current_url = $("p.current_url").text();
        $(".partage_post_url input").val(current_url);
    }

    let divClickable = document.getElementsByClassName('clickable-item');
    for (let i = 0; i < divClickable.length; i++) {
        divClickable[i].addEventListener('click', function(){
            if(this.getElementsByTagName('a')[0] !== undefined){
                location.href = this.getElementsByTagName('a')[0].getAttribute("href");
            }
        }, false);
    }
});
